import React, {useEffect, useRef, useState} from "react";
import {ImageBar} from "./Image.style";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {adjustDivHeight, adjustImageWidth} from "./AdjustImageSize";

function Image(props) {
    const containerRef = useRef();
    const [image, setImage] = useState(props.s7Picture || props.path || '');
    const [width, setWidth] = useState(props.originalWidth);
    const [height, setHeight] = useState(props.originalHeight);
    const [containerHeight, setContainerHeight] = useState(props.originalHeight);
    const isGif = props.picture?.toLowerCase().endsWith('.gif') ||
                      props.picture?.toLowerCase().includes('format=gif');
    const {
        picture,
        s7Picture,
        alt,
        text,
        imageHtmlId,
        title,
        isFullWidth,
        shadow,
        link,
        target,
        verticalAlignment,
        horizontalAlignment,
        originalWidth,
        originalHeight,
        alignTo,
				isInEditor,
				imagePlacementMobile
    } = props;

    useEffect(() => {
        if(s7Picture && !isGif){
            const {wid, hei} = adjustImageWidth(s7Picture, containerRef, originalWidth, originalHeight);
            setImage(`${s7Picture}&wid=${wid}&hei=${hei}`)
            setWidth(wid);
            setHeight(hei);
        }else{
            setImage(picture);
        }
    }, [picture, s7Picture]);

    useEffect(() => {
        setContainerHeight(adjustDivHeight(containerRef.current, alignTo, imagePlacementMobile));
    }, [props]);

    return (
        <ImageBar containerHeight={containerHeight} id={imageHtmlId} imageWidth={props.width} isFullWidth={isFullWidth} shadow={shadow}
                  ref={containerRef} className={`${verticalAlignment} ${horizontalAlignment} ${!image && isInEditor ? "setMinHeight" : ""}`}>
            <div className="image__content">
                {link ? (
                    <>
                        <div className={"image__upload__shadow"}>
                            <a className="image__link" href={link} target={target}>
                                <LazyLoadImage
                                    height={height} width={width} className="image__upload"
                                    src={image} alt={alt}
                                    title={title}
																		style={{
																			objectFit: "cover",
																			aspectRatio: props.detail && props.detail.width > 0 ? `${props.detail.width}/${props.detail.height}` : "unset",
																			width: props.width || `${isFullWidth ? '100%' : 'auto'}`,
																			height: props.height || "auto"
																		}}/>
                            </a>
                        </div>

                        <div>
                            {text && <p className="image__text p-small">{text}</p>}
                        </div>
                    </>
                ) : (
                    <>
                        <div className={"image__upload__shadow"}>
                            <LazyLoadImage
                                height={height} width={width} className="image__upload"
                                src={image} alt={alt}
                                title={title}
																style={{
																	objectFit: "cover",
																	aspectRatio: props.detail && props.detail.width > 0 ? `${props.detail.width}/${props.detail.height}` : "unset",
																	width: props.width || `${isFullWidth ? '100%' : 'auto'}`,
																	height: props.height || "auto"
																}}/>
                        </div>

                        <div>
                            {text && <p className="image__text p-small">{text}</p>}
                        </div>
                    </>
                )}
            </div>
        </ImageBar>
    );
}

const ImageHandleErrors = (props) => {
    return (
        <ErrorBoundary
            fallback={
                props.isInEditor || urlHasParam("wcmmode=disabled") ? (
                    <div style={{minHeight: "50px", display: "flex", alignItems: "center", backgroundColor: "#ffe1db"}}>
                        <p>The image component is currently experiencing errors. Please try again later.</p>
                    </div>
                ) : (
                    <div></div>
                )
            }
        >
            <Image {...props} />
        </ErrorBoundary>
    );
};

export default ImageHandleErrors;
